module.exports = __webpack_public_path__ + "img/image-placeholder.7278c971.png";